import { canv } from "@/canv/global.js";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { DocumentViewerWidget } from "@/elements/documentViewer/DocumentViewer";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

const sanitizeFileName = (name: string): string => {
    // Убираем все .pdf / .ppt / .pptx (без учёта регистра), если они идут в конце
    return name.replace(/(\.(pdf|pptx?|PDF|PPTX?))+$/g, "");
};

export class WmDocumentReName extends wmBase {
    constructor(options: widgetOption<string>[]) {
        super();
        this.name = options[0].value;
    }

    build() {
        const isEditorOrOwner = canv.isBoardModeEditOrOwner();

        return `
            <div class="wm_documentReName">
                <input
                    ${isEditorOrOwner ? "" : "disabled"}
                    value="${this.name}" 
                    class="documentNameInputField"
                />
            </div>
        `;
    }

    init() {
        const input = document.querySelector<HTMLInputElement>(".documentNameInputField");
        if (input) {
            input.addEventListener("focus", this.handleInputFocus);
            input.addEventListener("blur", this.handleInputBlur);
            input.addEventListener("keydown", this.handleInputKeydown);
        }
    }

    isValidFileName = (name: string): boolean => {
        const regex =
            /^(?!^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$)(?![ .])(?!.*[ .]$)[a-zA-Zа-яА-Я0-9 _.,\-()]{1,255}$/;
        return regex.test(name);
    };

    handleInputFocus = (e: FocusEvent): void => {
        canv.appInterface.inputFocused = 1;
        const input = e.currentTarget as HTMLInputElement;
        input.classList.add("active");
    };

    handleInputBlur = (e: FocusEvent): void => {
        canv.appInterface.inputFocused = 0;
        const input = e.currentTarget as HTMLInputElement;
        input.classList.remove("active");
        this.reNameDocument(input.value);
    };

    handleInputKeydown = (e: KeyboardEvent): void => {
        if (e.key === "Enter") {
            e.preventDefault();
            const input = e.currentTarget as HTMLInputElement;
            input.blur();
        }
    };

    reNameDocument(name: string) {
        const selectedEntities = canv.canvasController.selected;
        const isDocumentViewer = (obj: ExtendsOfElementBase): obj is DocumentViewerWidget =>
            obj?.constructorName === "documentViewer";

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && isDocumentViewer(child)) {
                const newName = sanitizeFileName(name.trim());
                const input = document.querySelector<HTMLInputElement>(".documentPageInputField");
                if (this.isValidFileName(newName)) {
                    if (input) input.value = newName;
                    child.reNameDocument(newName);
                } else {
                    canv.widgetMenu.reopen();
                }
            }
        }
    }

    name = "";
}
